var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99998C6.83001 9.99998 5.41668 8.58665 5.41668 5.41665C5.41668 2.24665 6.83001 0.833313 10 0.833313C13.17 0.833313 14.5833 2.24665 14.5833 5.41665C14.5833 8.58665 13.17 9.99998 10 9.99998ZM11.6992 11.7608C11.4192 12.2308 11.1108 12.6925 10.7817 13.1483C11.1208 14.2616 11.4083 15.385 11.6167 16.5241C11.7283 17.025 11.3467 17.5 10.8333 17.5H9.16668C8.65335 17.5 8.27251 17.025 8.38335 16.5241C8.55751 15.4516 8.84918 14.3375 9.20085 13.2008C8.85668 12.7441 8.54168 12.2658 8.26168 11.7641C4.50834 12.2191 2.71251 14.2841 2.50084 18.2891C2.48918 18.5175 2.57168 18.7408 2.72834 18.9066C2.88501 19.0725 3.10418 19.1666 3.33334 19.1666H16.6667C16.895 19.1666 17.1142 19.0725 17.2717 18.9066C17.4283 18.7408 17.5108 18.5175 17.4992 18.2891C17.2867 14.2708 15.4783 12.2075 11.6992 11.7608Z",
    fill: "url(#paint0_linear_192_396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_396",
    x1: 10,
    y1: 0.833313,
    x2: 10,
    y2: 19.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacement);
export default __webpack_public_path__ + "static/media/placement.6fa03c49b4021fb798e72c1767b61cb1.svg";
export { ForwardRef as ReactComponent };